import React, { Component } from 'react';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import { SetDirector } from './Widget';

class Bo extends Component {
    constructor(props) {
        super(props);
        const searchParams = {};
        this.state = {
            searchParams,
            curParams: {...searchParams},
            loading: false,
            data: [],
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { curParams } = this.state;
        const { ...rest } = curParams;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.queryByAreaGroup, {
            ...rest,
        }).then(res => {
            const { data } = res;
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({ curParams: searchParams }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 120,
        }, {
            title: '区域带教主管工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
        }, {
            title: '区域带教主管姓名',
            dataIndex: 'supervisorName',
            key: 'supervisorName',
            width: 120,
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 80,
            render: (text, record) => {
                return <a onClick={() => this.setDirector(record)}>设置带教主管</a>
            }
        }];
        return columns;
    }

    setDirector = (record) => {
        this.setDirectorRef.show(record);
    }

    render() {
        const { data, loading } = this.state;
        return (
            <div className="main">
                <TableC
                    loading={loading}
                    columns={this.getColumns()}
                    data={data}
                    pagination={false}
                    rowKey="director"
                />
                <SetDirector ref={el => this.setDirectorRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Bo;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/Bo.js